import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import AboutusIntro from "../../../assets/images/AboutUsIntroPic.png";
import theme from '../../../theme';

function AboutUsIntroComponent() {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={AboutusIntro}
        loading='eager'
        alt="About Us Intro"
        sx={{
          width: "50%",
          height: "auto",
          maxHeight: isMobile ? "none" : "50vh",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}

export default AboutUsIntroComponent;
